import { client } from '../utils/api';

interface Currencies {
	countries: string[];
	currencies: string[];
}
interface ConversionModal {
	amount: string | number;
	conversionAmount: string | number;
}

export interface TransactionData {
	id: string;
	clabe: string;
	beneficiary: string;
	amount: number;
	concept: string;
	currency: string;
	country: string;
	exchange: number;
	merchantCode: string;
}

export const getCurrencies = async () => {
	try {
		const params = Object();
		const { data } = await client.get<Currencies>('/v1/payouts/international/currencies', {
			params,
		});
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const postConversion = async ({ amount, conversionAmount }: ConversionModal) => {
	try {
		const body = {
			amount,
			conversionAmount,
		};

		const { data } = await client.post('/v1/payouts/international/conversion', body);
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const postGenerateInternational = async (props: TransactionData) => {
	const params = { merchant_code: props.merchantCode };
	try {
		const body = {
			id: props.id,
			clabe: props.clabe,
			beneficiary: props.beneficiary,
			amount: props.amount,
			concept: props.concept,
			currency: props.currency,
			country: props.country,
			exchange: props.exchange,
		};

		const { data } = await client.post('/v1/payouts/international/generate', body, {
			params,
		});
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const InternationalServices = {
	getCurrencies,
	postConversion,
	postGenerateInternational,
};
